import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "drawer", -1)

import { ref, watch,computed } from 'vue';
import { useTheme } from 'vuetify';
import { COLORS_IN_HTML, changeColor } from '@/constants/colors';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorSelectView',
  setup(__props) {

const theme = useTheme();
const isDarkMode    = computed(() => theme.global.name.value === 'darkCustom')
const colorPick     = ref(COLORS_IN_HTML.value.drawer);
const colorPickBG   = ref(theme.global.current.value.colors.background);

watch(colorPick,(color:string) => {
    // COLORS.COLORS_IN_HTML.value.drawer = color;
    changeColor(color);
})
watch(colorPickBG,(color:string) => {
    if(isDarkMode.value){
      theme.themes.value.darkCustom.colors.background = color??''
    }else{
        theme.themes.value.lightCustom.colors.background = color??''
    }
  
})


return (_ctx: any,_cache: any) => {
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_v_color_picker, {
            modelValue: colorPick.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((colorPick).value = $event)),
            "hide-inputs": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, "background - " + _toDisplayString(isDarkMode.value ? "DarkMode" : "LightMode") + " - " + _toDisplayString(colorPickBG.value), 1),
          _createVNode(_component_v_color_picker, {
            modelValue: colorPickBG.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((colorPickBG).value = $event)),
            "hide-inputs": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})